<template>
    <div class="uk-width-1-1">
        <div class="events-list uk-child-width-1-3@m" uk-grid uk-height-match target=".uk-card" row="false">
            <div v-for="item in items">
                <div class="event-card uk-card uk-card-default uk-card-small">
                    <div v-if="item.featured_media" class="event-card__media uk-card-media-top" v-html="item.featured_media.data.thumbnail">
                    </div>
                    <div class="event-card__body uk-card-body">
                        <h3 class="event-card__title uk-card-title">{{item.title}}</h3>
                        <p class="event-card__subtitle">{{item.subtitle}}</p>
                        <ul class="event-card__info uk-list uk-list-divider">
                            <li>
                                <div class="uk-flex uk-flex-middle">
                                    <i class="fal fa-clock"></i>
                                    <div class="uk-text-small uk-margin-small-left">
                                        {{item.starts_at.long}}<br/>
                                        {{item.ends_at.long}}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <a class="uk-position-cover" :href="item.url"></a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/collections/assets/js/components/EventsDataGridResults.vue